<script setup>
const props = defineProps({
  radioOption: String,
  modelValue: String,
  name: String,
  error: String,
  value: String,
  required: Boolean,
  options: Array,
  form: Object,
  onChange: { type: Function }
})

const model = defineModel()
const other = defineModel('other-text')

function update(val) {
  model.value = val
}

</script>

<template>
  <div class="input input--radio-group">
    <fieldset>
      <legend v-if="$slots.question">
        <p class="input__question">
          <slot name="question"></slot>
          <i class="fas fa-asterisk" v-if="required"></i>
        </p>
      </legend>

      <small class="text-muted input__description" v-if="$slots.description">
        <slot name="description"></slot>
      </small>

      <div class="input__controls">
        <div
          class="form-group form-check"
          v-for="opt in options"
          v-bind:key="opt.value"
        >
          <input
            :id="opt.value"
            @change="update($event.target.value)"
            type="radio"
            :name="name"
            class="form-check-input"
            :value="opt.value"
            :required="required"
           /> 

           <label
            class="form-check-label form-label"
            :for="opt.value"
            :data-input-name="name"
          >
            {{ opt.label }}
          </label>

          <small
            v-if="opt.description"
            class="text-muted d-block input__description"
            v-text="opt.description"
          ></small>

          <div
            v-if="opt.hasTextarea && opt.textareaName && model == opt.value"
            class="ps-3"
          >
            <textarea
              rows="4"
              class="form-control"
              :name="opt.textareaName"
              :value="form[opt.textareaName]"
              v-model="other"
              :aria-labelledby="opt.value"
            ></textarea>

            <p
              class="form-error"
              v-if="form.errors.get(opt.textareaName)"
              v-text="form.errors.get(opt.textareaName)"
              role="alert"
              aria-live="assertive"
            ></p>
          </div>
        </div>
      </div>
    </fieldset>
    <p class="form-error" v-if="error" v-text="error" role="alert" aria-live="assertive"></p>
  </div>
</template>